import Choices from 'choices.js';

export class WbForm {
  constructor() {
    this.languages = {
      fr: {
        errorBannerMessage:
          "Désolé, une erreur s'est produite lors de l'envoi du formulaire. Veuillez réessayer.",
        successBannerMessage: 'Le formulaire a été soumis avec succès!',
      },
    };
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;
    const inputElementList = document?.querySelectorAll('.field__input');
    const selectElementList = document?.querySelectorAll('.field__group > select, .wb-point-of-sales-search__form select');

    selectElementList?.forEach(select => {
      select.closest('.field__group')?.classList.add('field__group--select');
      const choices = new Choices(select, {
        searchEnabled: false,
        itemSelectText: '',
      });
    });

    inputElementList?.forEach(input => {
      if (input?.value !== '') {
        input.previousElementSibling?.classList.add('--active');
      }
    });

    document
      .querySelector('body')
      ._addCustomEventListener('focusin', '.field__input', _this.inputFocusIn.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('focusout', '.field__input', _this.inputFocusOut.bind(_this));

    this.overrideAjaxMessages();
    this.addFileLabelClass();
  }

  inputFocusIn(e) {
    const ele = e.targetElement;
    ele.previousElementSibling?.classList.add('--active');
  }

  inputFocusOut(e) {
    const ele = e.targetElement;

    if (!ele.value.length) {
      ele.previousElementSibling?.classList.remove('--active');
    }
  }

  addFileLabelClass() {
    document.querySelectorAll('.field__input[type="file"]')?.forEach(input => {
      input.previousElementSibling.classList.add('field__label--file');
    });
  }

  overrideAjaxMessages() {
    const languages = this.languages;

    document.addEventListener('freeform-ready', function(event) {
      // Set AJAX validation to true by default
      event.options.ajax = true;

      for (const [language, messages] of Object.entries(languages)) {
        if (document.querySelector(`html[lang*="${language}"]`)) {
          event.options.errorBannerMessage = messages.errorBannerMessage;
          event.options.successBannerMessage = messages.successBannerMessage;
        }
      }
    });
  }
}
